import { NgxSpinnerService } from 'ngx-spinner';

/**
 * Abstract Form Component
 * @description abstract class used for hide/show Spinner for all class that require it
 */
export abstract class AbstractFormComponent {
  constructor(protected ngxSpinner: NgxSpinnerService) {}

  protected abstract getSpinnerName(): string;

  public showSpinner(name?: string): void {
    this.ngxSpinner.show(name || this.getSpinnerName(), {
      zIndex: 1049,
    });
  }

  public hideSpinner(name?: string): void {
    this.ngxSpinner.hide(name || this.getSpinnerName());
  }
}
